module.exports = __webpack_public_path__ + "img/ARGOstqr_Digital_logo_banner.4e62a4ce.png";